import React from 'react'
import {
  Grid,
  Drawer,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Checkbox,
  FormControlLabel,
  ListItemIcon,
} from '@material-ui/core'
import { toast } from 'react-toastify'
import _ from 'lodash'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import { makeStyles } from '@material-ui/styles'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { COMMENTS, CREATE_COMMENT } from './queries'
import CustomTooltip from '../../../../../../components/CustomTooltip'
import decodeJWT from 'jwt-decode'

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  dialogStatement: {
    fontSize: 16,
    fontWeight: 600,
  },
  dialogContentRoot: {
    height: '85%',
    overflowX: 'unset',
  }
}))

function CommentsDrawer(props) {
  const classes = useStyles()
  const currentUserId = localStorage.getItem('userId')
  const [content, setContent] = React.useState()
  const [isPrivate, setIsPrivate] = React.useState(false)
  const { data } = useQuery(COMMENTS, {
    variables: {
      questionId: props.questionId || 0
    },
    pollInterval: 1500,
    fetchPolicy: 'cache-and-network'
  })

  const [createComment] = useMutation(CREATE_COMMENT)

  // if (error) return <p>{ error.message }</p>

  const userProfile = decodeJWT(localStorage.getItem('token')).profile

  const handleTogglePrivate = () => {
    setIsPrivate(!isPrivate)
  }

  const handleCreateComment = () => {
    createComment({
      variables: {
        questionId: props.questionId,
        content,
        isPrivate,
      },
    })
    toast.success('Comentário enviado com sucesso. Ele agora será avaliado pela equipe do ISE B3.');

    setContent('')
    setIsPrivate(false)
  }

  const handlePrivateComments = (comment) => {
    return (
      userProfile === 'administrator' ||
      userProfile === 'manager' ||
      !comment.isPrivate ||
      comment.userId == currentUserId
    )
  }

  const makeComment = (comment) => (
    <ListItem>
      <Grid container justify="space-between" alignItems="center">
        <Grid item xs={ 1 }>
          <ListItemIcon>
            { comment.isPrivate && <VisibilityOffIcon fontSize="small" /> }
          </ListItemIcon>
        </Grid>
        <Grid item xs={ 8 }>
          <ListItemText>
            <Typography align="justify" style={{ wordBreak: 'break-word' }}>
              { comment.content }
            </Typography>
          </ListItemText>
        </Grid>
        <Grid item xs={ 3 }>
          <ListItemText style={{ flexDirection: 'column' }}>
            <Typography align="right" color="textSecondary">
              { comment.userName }
            </Typography>
            <Typography align="right" color="textSecondary">
              { comment.createdAt }
            </Typography>
          </ListItemText>
        </Grid>
      </Grid>
    </ListItem>
  )

  return (
    <Drawer
      anchor="right"
      open={ !!props.questionId }
      onClose={ props.closeDialog }
    >
      <div style={{ maxWidth: 700, height: '95%', display: 'flex', flexDirection: 'column' }}>
        <DialogTitle id="comment-dialog" className={ classes.dialogTitle }>
          <strong>Comentários</strong>
        </DialogTitle>
        <DialogContent classes={{ root: classes.dialogContentRoot }}>
          <DialogContentText color="textPrimary" className={ classes.dialogStatement }>
            { /* { _.get(props, 'questionData.dimensionAbbreviation') }
            { ' ' }
            { _.get(props, 'questionData.hierarchy') }
            { ' - ' } */ }
            { props.questionData && (_.get(props, 'questionData.statement') || []).split("\n").map((line, index)=>{
              return [
                index !== 0 ? ( <br></br> ) : null,
                line
              ];
            }) }
          </DialogContentText>
          <div style={{ height: '85%', flexGrow: 1, overflowY: 'scroll' }}>
            <List dense>
              {
                data &&
                data.commentsPerQuestion &&
                data.commentsPerQuestion
                  .filter(handlePrivateComments)
                  .map(makeComment)
              }
            </List>
          </div>
        </DialogContent>
        <DialogActions>
          <Typography align="justify" variant="caption">
            Lembre-se de incluir uma justificativa para sua sugestão,
            mencionando também, sempre que possível, referências que a apóiem
          </Typography>
        </DialogActions>
        <DialogActions>
          <TextField
            fullWidth
            multiline
            onKeyPress={ event => event.key === 'Enter' && handleCreateComment() }
            placeholder="Digite o seu comentário aqui!"
            value={ content }
            onChange={ event => setContent(event.target.value) }
          />
        </DialogActions>
        <DialogActions>
          <CustomTooltip
            placement="top"
            title="Um comentário marcado como privado só pode ser visualizado pela equipe ISE B3"
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={ isPrivate }
                  onChange={ handleTogglePrivate }
                  name="is-private"
                  color="primary"
                  size="small"
                />
              }
              label="Privado?"
            />
          </CustomTooltip>
          <Button onClick={ handleCreateComment } color="primary">
            Enviar
          </Button>
          <Button onClick={ props.closeDialog } color="secondary">
            Fechar
          </Button>
        </DialogActions>
      </div>
    </Drawer>
  )
}

export default CommentsDrawer
